export default "__VITE_ASSET__BiNU9idI__"